document.addEventListener("DOMContentLoaded", function(){

    const faqItems = document.querySelectorAll(".reveal");


    if(!faqItems.length) return;



    const observer = new IntersectionObserver((entries)=>{


        entries.forEach((entry,index)=>{


            if(entry.isIntersecting){


                setTimeout(()=>{

                    entry.target.classList.add("show");

                }, index * 120);


                observer.unobserve(entry.target);

            }


        });


    },{
        threshold:0.15
    });



    faqItems.forEach(item=>{

        observer.observe(item);

    });


});